import { useEffect, useRef } from "react";

/**
 * Adds `.in` class to children with `.fade-up` when they enter the viewport.
 * Gentle, CSS-only entrance animation per design guidelines.
 */
export default function FadeIn({ children, as: Tag = "div", className = "", delay = 0, ...rest }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => el.classList.add("in"), delay);
          io.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} className={`fade-up ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
